import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FileInput, MinusCircle, PlusCircle, Sun } from "lucide-react";
import AddEventFromTemplate from "../../../components/AddEventFromTemplate";
import { useScheduleContext } from "../../context/useScheduleContext";
import { useMenuContext } from "../../context/useMenuContext";
import { usePermissions } from "../../usePermissions";
import { useIsTemplate } from "../../useIsTemplate";

export const useCellMenu = () => {
    const { t } = useTranslation();
    const { dispatch, type } = useScheduleContext();
    const { selected, closeMenu } = useMenuContext();
    const isTemplate = useIsTemplate();
    const { canCreate } = usePermissions();

    return useMemo(() => {
        const menuItems = [
            {
                icon: PlusCircle,
                label: t("create"),
                onChange: () => {
                    dispatch({
                        type: "selected-cell-or-event",
                        payload: {
                            ...selected,
                            isCreating: true,
                            isTemplate
                        }
                    });
                    closeMenu()
                },
                hidden: !canCreate,
                disabled: false,
            },
            {
                icon: FileInput,
                label: t("add-from-template"),
                hidden: isTemplate || !canCreate || type === "home",
                disabled: false,
                submenu: {
                    key: "add-template",
                    content: (
                        <AddEventFromTemplate
                            key={selected?.id}
                            selected={selected}
                            closeMenu={closeMenu}
                        />
                    )
                },
            },
            {
                icon: Sun,
                label: t("add-time-off"),
                onChange: (value: any) => {
                    console.log({ addTimeoff: value });
                },
                hidden: true,
                disabled: false,
            },
            {
                icon: MinusCircle,
                label: t("add-unavailability"),
                onChange: (value: any) => {
                    console.log({ addTimeoff: value });
                },
                hidden: true,
                disabled: false,
            },
        ];
        return menuItems.filter((item: any) => !item.hidden);
    }, [dispatch, closeMenu, selected, canCreate, isTemplate, type, t]);
}
